module.exports = __webpack_public_path__ + "static/media/fingerprint-outline.a08d6bc5.svg";